import mutations from './mutations'
import actions from './actions'
import getters from './getters'


export default {
  namespaced: true,
  state: {
    selections: [],
    notificationList:{
    	category:'M',
      onChangeState:false, 
    }
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/Crm/store/index.js